import { useEffect, useState } from 'react'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string
}

const Image = ({ src, fallbackSrc, onError, ...props }: ImageProps) => {
  const [currentSrc, setCurrentSrc] = useState(src)

  useEffect(() => {
    setCurrentSrc(src)
  }, [src])

  if (!currentSrc) return null

  return (
    <img
      {...props}
      src={currentSrc}
      onError={e => {
        if (fallbackSrc && currentSrc !== fallbackSrc) {
          setCurrentSrc(fallbackSrc)
          return
        }

        setCurrentSrc(undefined) // fallback도 실패하면 완전 제거
        onError?.(e)
      }}
    />
  )
}

export default Image
